module.exports = __webpack_public_path__ + "img/left_5.6cae2236.png";